import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.25 12a8.75 8.75 0 0 1 15-6.123V4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h2.477A7.25 7.25 0 1 0 19.25 12a.75.75 0 0 1 1.5 0 8.75 8.75 0 1 1-17.5 0"
  }));
}
var IcRefresh = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRefresh));

export { IcRefresh as I };
